import { Component, Input, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-version-img-viewer',
  templateUrl: './version-img-viewer.component.html',
  styleUrls: ['./version-img-viewer.component.scss']
})
export class VersionImgViewerComponent implements AfterViewInit {
  version: any;

  private scale = 1;
  private panning = false;
  private pointX = 0;
  private pointY = 0;
  private start = { x: 0, y: 0 };
  private initialPinchDistance: number | null = null;

  @ViewChild('carouselContainer') carouselContainer!: ElementRef<HTMLElement>;

  constructor(public config: DynamicDialogConfig, private renderer: Renderer2) {
    if (config.data) {
      this.version = config.data[0];
    }
  }

  ngAfterViewInit(): void {
    const container = this.carouselContainer.nativeElement;
    container.addEventListener('mousedown', this.onPointerDown.bind(this));
    container.addEventListener('touchstart', this.onPointerDown.bind(this));
    container.addEventListener('mouseup', this.onPointerUp.bind(this));
    container.addEventListener('touchend', this.onPointerUp.bind(this));
    container.addEventListener('mousemove', this.onPointerMove.bind(this));
    container.addEventListener('touchmove', this.onPointerMove.bind(this));
    container.addEventListener('wheel', this.onWheel.bind(this));
  }

  private getActiveImage(): HTMLImageElement | null {
    const image = this.carouselContainer.nativeElement.querySelector('.product-img');
    return image as HTMLImageElement | null;
  }

  private setTransform(img: HTMLImageElement): void {
    this.renderer.setStyle(img, 'transform', `translate(${this.pointX}px, ${this.pointY}px) scale(${this.scale})`);
  }

  onPointerDown(e: MouseEvent | TouchEvent): void {
    const img = this.getActiveImage();
    if (!img) return;

    e.preventDefault();
    if (e instanceof TouchEvent && e.touches.length === 2) {
      this.initialPinchDistance = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
    } else {
      const point = e instanceof TouchEvent ? e.touches[0] : e;
      this.start = { x: point.clientX - this.pointX, y: point.clientY - this.pointY };
      this.panning = true;
    }
  }

  onPointerUp(e: MouseEvent | TouchEvent): void {
    this.panning = false;
    this.initialPinchDistance = null;
  }

  onPointerMove(e: MouseEvent | TouchEvent): void {
    const img = this.getActiveImage();
    if (!img) return;

    e.preventDefault();
    if (e instanceof TouchEvent && e.touches.length === 2 && this.initialPinchDistance) {
      
      const newDist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
      const scaleFactor = newDist / this.initialPinchDistance;
      this.scale *= scaleFactor;
      this.scale = Math.max(1, Math.min(this.scale, 5)); 
      this.initialPinchDistance = newDist;
      this.setTransform(img);
    } else if (this.panning) {
   
      const point = e instanceof TouchEvent ? e.touches[0] : e;
      this.pointX = point.clientX - this.start.x;
      this.pointY = point.clientY - this.start.y;
      this.setTransform(img);
    }
  }

  onWheel(e: WheelEvent): void {
    const img = this.getActiveImage();
    if (!img) return;

    e.preventDefault();
    const xs = (e.clientX - this.pointX) / this.scale;
    const ys = (e.clientY - this.pointY) / this.scale;
    const delta = -e.deltaY;

    const newScale = this.scale * (delta > 0 ? 1.1 : 0.9);
    this.scale = Math.max(1, Math.min(newScale, 5));

    if (this.scale === 1) {
      this.pointX = 0;
      this.pointY = 0;
    } else {
      this.pointX = e.clientX - xs * this.scale;
      this.pointY = e.clientY - ys * this.scale;
    }

    this.setTransform(img);
  }
}